import React from 'react';
import { IconsPros } from './types';

/**
 * Lightbox Icon component
 *
 * @returns JSX.ELEMENT
 */
export const LightboxIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M13.45,3.78l.31-.35a.12.12,0,0,0,0-.18.13.13,0,0,0-.19,0l-.29.34L13,3.25a.13.13,0,0,0-.19,0,.12.12,0,0,0,0,.18l.32.35-.31.35a.12.12,0,0,0,0,.18.13.13,0,0,0,.19,0L13.28,4l.29.34a.13.13,0,0,0,.19,0,.12.12,0,0,0,0-.18ZM13.28,5a1.22,1.22,0,1,1,1.24-1.22A1.23,1.23,0,0,1,13.28,5Zm-1.92,5H4.57a.16.16,0,0,0-.16.16v.44a.16.16,0,0,0,.16.16h6.78a.16.16,0,0,0,.16-.16v-.44A.16.16,0,0,0,11.35,10Zm0-2.38H4.57a.16.16,0,0,0-.16.16v.44a.16.16,0,0,0,.16.16h6.78a.16.16,0,0,0,.16-.16V7.75A.16.16,0,0,0,11.35,7.59Zm0-2.38H4.57a.16.16,0,0,0-.16.16v.44A.16.16,0,0,0,4.57,6h6.78a.16.16,0,0,0,.16-.16V5.37A.16.16,0,0,0,11.35,5.21Zm1.84,7.2H2.79a.14.14,0,0,1-.14-.14V3.73a.14.14,0,0,1,.14-.14h8.95a1.33,1.33,0,0,0,0,.32,1.39,1.39,0,0,0,1.41,1.38l.23,0v7A.14.14,0,0,1,13.2,12.41ZM13.44,0H2.56A2.5,2.5,0,0,0,0,2.44V13.56A2.5,2.5,0,0,0,2.56,16H13.44A2.5,2.5,0,0,0,16,13.56V2.44A2.51,2.51,0,0,0,13.44,0Z" />
    </svg>
  );
};
